import { TaskIdV2, UserId } from 'api/models';
import { client } from './client';
import { TaskTimeEntry } from './types';

const getTaskTimeEntriesForUser = (
  [, userId]: UserId,
  [, taskId]: TaskIdV2,
  endDate: string,
): Promise<TaskTimeEntry[]> =>
  client.get(
    `/time-entries?userId=${userId}&taskId=${taskId}&endDate=${endDate}`,
  );

export const TimeEntriesApi = {
  getTaskTimeEntriesForUser,
};
